const VOLUME_UNIT_TYPE = 'volume';
const DISTANCE_UNIT_TYPE = 'distance';

export const UNITS = {
  meter: {
    name: 'meter',
    symbol: 'm',
    type: DISTANCE_UNIT_TYPE,
    conversion: 1,
  },
  kilometer: {
    name: 'kilometer',
    symbol: 'km',
    type: DISTANCE_UNIT_TYPE,
    conversion: 1 / 1000,
  },
  mile: {
    name: 'mile',
    symbol: 'mi',
    type: DISTANCE_UNIT_TYPE,
    conversion: 1 / 1609.344,
  },
  liter: {
    name: 'liter',
    symbol: 'L',
    type: VOLUME_UNIT_TYPE,
    conversion: 1,
  },
  gallon: {
    name: 'gallon',
    symbol: 'gal',
    type: VOLUME_UNIT_TYPE,
    conversion: 1 / 3.785411784, // US-Gal,
  },
  ukGallon: {
    name: 'uk-gallon',
    symbol: 'gal',
    type: VOLUME_UNIT_TYPE,
    conversion: 1 / 4.546090282, // UK-Gal,
  },
};

export enum UnitSystem {
  US_CUSTOMARY = 'us-customary',
  METRIC = 'metric',
  IMPERIAL = 'imperial',
}

export const US_CUSTOMARY_UNIT_SYSTEM = UnitSystem.US_CUSTOMARY;
export const METRIC_UNIT_SYSTEM = UnitSystem.METRIC;
export const IMPERIAL_UNIT_SYSTEM = UnitSystem.IMPERIAL;

export const DEFAULT_UNITS = {
  [METRIC_UNIT_SYSTEM]: {
    [VOLUME_UNIT_TYPE]: UNITS.liter,
    [DISTANCE_UNIT_TYPE]: UNITS.kilometer,
  },
  [IMPERIAL_UNIT_SYSTEM]: {
    [VOLUME_UNIT_TYPE]: UNITS.ukGallon,
    [DISTANCE_UNIT_TYPE]: UNITS.mile,
  },
  [US_CUSTOMARY_UNIT_SYSTEM]: {
    [VOLUME_UNIT_TYPE]: UNITS.gallon,
    [DISTANCE_UNIT_TYPE]: UNITS.mile,
  },
};

export const UNIT_TRANSLATIONS = {
  [UNITS.kilometer.symbol]: 'units.km',
  [UNITS.mile.symbol]: 'units.mi',
};
